import React, { useEffect, useState } from "react";
import LaunchpadList from "../Components/Launchpad/LaunchpadList";
import Listactive from "../Components/Listactive";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { BsSearch } from "react-icons/bs";
import Search from "../Components/Search/Search";
import { _InfinityFactoryContractGetDataByAddress } from "../Services/Web3Connection";
import { _InfinityFactoryContractGetAllDataByAddress } from "../Services/Web3Connection";
import StatusTab from "../Components/NavTabs/StatusTab";
// import Footer2 from "../Components/Footer2";
import Footer2 from "../Components/Footer2";
import styled from "styled-components";

const LaunchpadPage = (props) => {
  const [ContractData, setContractData] = useState([]);
  useEffect(async () => {
    let data = await _InfinityFactoryContractGetAllDataByAddress();
    setContractData(data);
  }, []);
  return (
    <>
      <img
        className="infinitypageimg"
        src={process.env.PUBLIC_URL + "/assets/images/bg1.jpg"}
        alt="..."
      />
      <div className="">
        <Header Connect={props.Connect} setConnect={props.setConnect} />
        <div className="container">
          <div class="row">
            <div className="col-md-12">
              <div
                data-v-5b46e2aa=""
                class=" col-md-6 header all__header"
                style={{ margin: "0px -40px" }}
              >
                <div data-v-5b46e2aa="" class="header__top-taber">
                  <div data-v-5b46e2aa="" class="top-taber ml-3">
                    <Link to="/launchpad">
                      <a
                        style={{
                          color: "#dd6f20",
                          fontSize: "2rem",
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                        data-v-5b46e2aa=""
                        href="/projects?type=launch"
                        // class="top-taber__label nuxt-link-exact-active nuxt-link-active top-taber__label_active"
                        aria-current="page"
                      >
                        Launchpad/
                      </a>
                    </Link>

                    <Link to="/claim">
                      <a
                        style={{
                          color: "#979797",
                          fontSize: "2rem",
                          fontWeight: "bold",
                        }}
                        data-v-5b46e2aa=""
                        href="/projects?type=stake"
                        // class="top-taber__label nuxt-link-active"
                      >
                        Claim
                      </a>
                    </Link>
                  </div>
                  <div className="col-md-12">
                    <div data-v-5b46e2aa="" class=" top-taber__break"></div>
                    <div data-v-5b46e2aa="" class="  top-taber__line"></div>
                    <div
                      data-v-7107b216=""
                      class="top-taber__line top-taber__line_left"
                    ></div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className=" projectdetails d-flex"
              style={{ zIndex: "100", margin: "0px -11px" }}
            >
              <div
                class=" col-xs-12 pt-4 categorytxt"
                // style={{ margin: "0px -11px" }}
              >
                <div className="col-md-12 " style={{ display: "flex" }}>
                  <span
                    className="text-white mx-2"
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      fontSize: "18px",
                    }}
                  >
                    Project Launched
                  </span>
                  <span
                    className=""
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      fontSize: "18px",
                      color: "#dd6f20",
                      fontWeight: "600",
                    }}
                  >
                    {ContractData.length}
                  </span>
                </div>
              </div>
              <div className=" col-xs-12 pt-4">
                <img
                  src={process.env.PUBLIC_URL + "assets/images/banner.jpg"}
                  class="img-fluid bannersimg"
                />
              </div>
            </div>
          </div>
          {/* ------------------------open Search--------------*/}
          <div className="col-md-12 mt-2">
            <div data-v-5b46e2aa="" class="all__search search">
              <div
                data-v-5b46e2aa=""
                class="d-flex p-2 justify-content-center search__field "
              >
                <div data-v-5b46e2aa="searchicon" style={{ zIndex: "100" }}>
                  {/* <Search Data={ContractData} /> */}
                  {/* <img
                    data-v-5b46e2aa=""
                    alt="seacrh"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjI4MjYgMTcuMTc3OEwyMyAyMy44OTUyTTE5LjE3MzkgMTAuMzQzMUMxOS4xNzM5IDE1LjUwMzEgMTUuMTA1NSAxOS42ODYyIDEwLjA4NyAxOS42ODYyQzUuMDY4MzcgMTkuNjg2MiAxIDE1LjUwMzEgMSAxMC4zNDMxQzEgNS4xODMwNSA1LjA2ODM3IDEgMTAuMDg3IDFDMTUuMTA1NSAxIDE5LjE3MzkgNS4xODMwNSAxOS4xNzM5IDEwLjM0MzFaIiBzdHJva2U9IiNGRjI4NEMiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K"
                  /> */}
                </div>{" "}
                <div
                  data-v-5b46e2aa=""
                  class="search__input"
                  style={{ zIndex: "100" }}
                >
                  {/* <LaunchpadComponent data={data} /> */}

                  {/* <input data-v-5b46e2aa="" placeholder="Search" type="text" style={{fontSize:'15px',fontWeight:'600',zIndex:'100'}} /> */}
                </div>
              </div>

              {/* -----------------Close Search------------------ */}
            </div>
          </div>
          <StatusTab />

          {/* <Listactive /> */}

          {/* <LaunchpadList />
          {/* <Launchcards /> */}
        </div>
        {/* <Footer /> */}
        {/* <Footer2 /> */}
      </div>
    </>
  );
};

export default LaunchpadPage;
